<template>
  <div>
    <div v-if="step === 1">
      <div>
        <h1>How we work</h1>
        <p class="description">
          Every day, people are faced with a multitude of tasks that they have
          to complete. Some may be work-related others mundane personal tasks
          such as washing the dishes and throwing out the trash. We recognize
          that these goals and tasks are highly customizable and vary from
          person to person, to date there is no easy way to track and score
          yourself day to day against your goals/tasks. This is where our
          product will help bridge the gap by giving people tools to better
          their lives and manage their day-to-day.
        </p>
      </div>
      <div>
        <img class="progressImage" src="../assets/howweworkcards.png" alt="" />
      </div>
      <div>
        <button class="btn" @click="step = 2">Next</button>
      </div>
    </div>
    <div v-else-if="step == 2">
      <div class="resourceOnboarding">
        <div class="resourceTitle">
          <h1>Useful Resources</h1>
        </div>
        <p class="resourceDescription">
          Research has shown that combining outcome, process, and performance
          goals increase the success rate. For effective goal setting, you
          should incorporate all three into your goal statement. Once you have
          set your outcome goals, you should stop focusing on the outcome(or end
          goal) and really focus daily on their process and performance goals
          which are the behaviors and standards that will get you to your end
          goal.
        </p>
        <p class="resourceLabel">
          Here are some useful resources for additional information:
        </p>
        <div class="resourceContainer">
          <img src="../assets/resource_img1.png" alt="" />
          <img src="../assets/resource_img2.png" alt="" />
          <img src="../assets/resource_img3.png" alt="" />
        </div>
        <div>
          <button class="btn" @click="next">Next</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  beforeCreate() {
    const getGoalURI = '/goal/'
    this.$axios
      .get(getGoalURI)
      .then((result) => {
        this.setStoreGoal(result.data.data)
        this.$router.push('/dashboard')
        console.log(result)
      })
      .catch((err) => {

        // this.$router.push('/home')
        console.log(err)
      })
  },
  data() {
    return {
      step: 1,
    };
  },
  methods: {
    ...mapActions(['setStoreGoal']),
    next() {
      this.$router.push("/")
    },
  },
};
</script>

<style scoped>
.container {
  display: block;
  justify-content: center;
  height: 100%;
}
.btn {
  width: 139px;
  height: 52px;
  margin-top: 25px;
  background: linear-gradient(
    96.18deg,
    #03a3f5 -5.4%,
    #b983ff 50.72%,
    #ffe883 85.14%
  );
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  border: 0px;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;
  cursor: pointer;
}
.description {
  width: 75%;
  text-align: center;
  margin: 15px auto;
  font-size: 16px;
}

.progressImage {
  width: 50%;
}

.resourceTitle {
}

.resourceOnboarding {
  height: 100%;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.resourceContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.resourceDescription {
  width: 75%;
  margin: 0 auto;
}

.resourceLabel {
  padding-top: 30px;
  font-style: italic;
  width: 50%;
  margin: 0 auto;
}

.resourceContainer {
  display: flex;
  flex-wrap: wrap;
}

.resourceContainer > img {
  width: 250px;
  margin: 20px;
}
</style>
